"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/core/styles");
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _Box = _interopRequireDefault(require("@material-ui/core/Box"));
var _colorManipulator = require("@material-ui/core/styles/colorManipulator");
var _SttContainerTitle = _interopRequireDefault(require("../SttTypography/SttContainerTitle"));
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _SttNotification = _interopRequireDefault(require("../SttNotification"));
var _SttText = _interopRequireDefault(require("../SttTypography/SttText"));
var _core = require("@material-ui/core");
var _SttTimeLine = _interopRequireDefault(require("../SttTimeLine"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var TIMELINE = 'TIMELINE';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _wrapper, _leftBox, _rigthBox;
  return {
    wrapper: (_wrapper = {}, _defineProperty(_wrapper, theme.breakpoints.up('sm'), {
      height: function height(props) {
        return props.possuiTabHeader ? 'calc(100vh - 210px)' : 'calc(100vh - 140px)';
      }
    }), _defineProperty(_wrapper, "flexDirection", 'row'), _defineProperty(_wrapper, "display", 'flex'), _defineProperty(_wrapper, "overflow", 'auto'), _wrapper),
    leftBox: (_leftBox = {
      height: '100%',
      width: '240px',
      overflow: 'hidden'
    }, _defineProperty(_leftBox, theme.breakpoints.up('lg'), {
      width: '280px'
    }), _defineProperty(_leftBox, theme.breakpoints.up('xl'), {
      width: '320px'
    }), _defineProperty(_leftBox, theme.breakpoints.up('md'), {
      width: '250px'
    }), _defineProperty(_leftBox, theme.breakpoints.down('sm'), {
      width: 0
    }), _leftBox),
    rigthBox: (_rigthBox = {
      height: '100%',
      width: 'calc(100% - 240px)'
    }, _defineProperty(_rigthBox, theme.breakpoints.up('lg'), {
      width: 'calc(100% - 280px)'
    }), _defineProperty(_rigthBox, theme.breakpoints.up('xl'), {
      width: 'calc(100% - 320px)'
    }), _defineProperty(_rigthBox, theme.breakpoints.up('md'), {
      width: 'calc(100% - 250px)'
    }), _defineProperty(_rigthBox, theme.breakpoints.down('sm'), {
      width: '100%'
    }), _defineProperty(_rigthBox, "display", 'flex'), _defineProperty(_rigthBox, "flexDirection", 'column'), _rigthBox),
    content: {
      flexGrow: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: theme.spacing(1),
      paddingTop: theme.spacing(0)
    },
    fixedHeader: {
      position: 'sticky',
      padding: theme.spacing(1),
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      top: 0,
      zIndex: 1
    },
    listItemSelected: {
      "&.Mui-selected": {
        backgroundColor: (0, _colorManipulator.alpha)(theme.palette.primary.main, 0.1),
        borderRadius: theme.spacing(1)
      }
    },
    listItemRoot: {
      color: theme.palette.primary.main
    },
    listItemText: {
      fontSize: '1rem'
    },
    listItemTextSelected: {
      fontWeight: 'bold'
    },
    alert: {
      marginBottom: theme.spacing(1)
    },
    notification: {
      display: 'flex',
      flexDirection: 'column'
    },
    conteudoTitulo: _defineProperty({
      fontWeight: 700,
      fontSize: '17.28px'
    }, theme.breakpoints.down('sm'), {
      fontWeight: 700,
      fontSize: '13px',
      textAlign: 'start'
    }),
    conteudoValor: _defineProperty({
      fontSize: '16px',
      width: '100%'
    }, theme.breakpoints.down('sm'), {
      fontSize: '13px',
      textAlign: 'end'
    }),
    dividerCelular: _defineProperty({
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      '&:last-child': {
        display: 'none'
      }
    }),
    gridDados: {
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      alignItems: 'center',
      gap: '100px'
    },
    linhasDados: {
      display: 'flex',
      flexDirection: 'column'
    },
    titulo: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      fontWeight: 700,
      fontSize: '24px'
    }
  };
});
var SttSection = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var botaoAcoes = props.botaoAcoes,
    titulo = props.titulo,
    _props$onClickVoltar = props.onClickVoltar,
    onClickVoltar = _props$onClickVoltar === void 0 ? null : _props$onClickVoltar,
    _props$botoes = props.botoes,
    botoes = _props$botoes === void 0 ? null : _props$botoes,
    _props$possuiTabHeade = props.possuiTabHeader,
    possuiTabHeader = _props$possuiTabHeade === void 0 ? true : _props$possuiTabHeade,
    _props$conteudo = props.conteudo,
    conteudo = _props$conteudo === void 0 ? [] : _props$conteudo,
    _props$notificacaoSup = props.notificacaoSuperior,
    notificacaoSuperior = _props$notificacaoSup === void 0 ? null : _props$notificacaoSup;
  var classes = useStyles({
    possuiTabHeader: possuiTabHeader
  });
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  var contentRefs = (0, _react.useRef)({});
  var scrollTimeout = (0, _react.useRef)(null);
  var isUserScrolling = (0, _react.useRef)(true);
  var contentElementRef = (0, _react.useRef)(null);
  var filteredConteudo = (0, _react.useMemo)(function () {
    return conteudo.filter(function (item) {
      return item.show;
    });
  }, [conteudo]);
  var handleItemClick = (0, _react.useCallback)(function (index, id, onClick) {
    isUserScrolling.current = false;
    setSelectedTab(index);
    onClick === null || onClick === void 0 ? void 0 : onClick();
    var targetDiv = contentRefs.current[id];
    if (targetDiv) {
      targetDiv.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setTimeout(function () {
        isUserScrolling.current = true;
      }, 500);
    }
  }, []);
  var handleScroll = (0, _react.useCallback)(function () {
    if (!isUserScrolling.current) return;
    clearTimeout(scrollTimeout.current);
    scrollTimeout.current = setTimeout(function () {
      var _contentElementRef$cu;
      var contentKeys = Object.keys(contentRefs.current);
      var boxTop = (_contentElementRef$cu = contentElementRef.current) === null || _contentElementRef$cu === void 0 ? void 0 : _contentElementRef$cu.getBoundingClientRect().top;
      var proximaTab = selectedTab;
      if (boxTop !== undefined) {
        for (var i = 0; i < contentKeys.length; i++) {
          var element = contentRefs.current[contentKeys[i]];
          if (element) {
            var _element$getBoundingC = element.getBoundingClientRect(),
              top = _element$getBoundingC.top,
              bottom = _element$getBoundingC.bottom;
            if (top <= boxTop + 100 && bottom > boxTop + 100) {
              proximaTab = i;
              break;
            }
          }
        }
        var container = contentElementRef.current;
        if (container && Math.ceil(container.scrollTop + container.clientHeight) >= container.scrollHeight - 1) {
          proximaTab = contentKeys.length - 1;
        }
      }
      if (proximaTab !== selectedTab) setSelectedTab(proximaTab);
    }, 100);
  }, [selectedTab]);
  (0, _react.useEffect)(function () {
    var contentElement = contentElementRef.current;
    if (contentElement) {
      contentElement.addEventListener('scroll', handleScroll);
    }
    return function () {
      if (contentElement) {
        contentElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [handleScroll]);
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.wrapper
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.leftBox
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    component: "nav"
  }, filteredConteudo.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      button: true,
      key: item.id,
      selected: index === selectedTab,
      disableRipple: true,
      onClick: function onClick() {
        return handleItemClick(index, item.id, item.onClick);
      },
      classes: {
        selected: classes.listItemSelected,
        root: classes.listItemRoot
      }
    }, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: item.titulo,
      classes: {
        primary: "".concat(classes.listItemText, " ").concat(index === selectedTab ? classes.listItemTextSelected : '')
      }
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: classes.rigthBox
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.fixedHeader
  }, notificacaoSuperior && /*#__PURE__*/_react["default"].createElement(_SttNotification["default"], {
    severity: notificacaoSuperior.severity || "info",
    className: classes.alert
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.notification,
    dangerouslySetInnerHTML: {
      __html: notificacaoSuperior.conteudo
    }
  })), /*#__PURE__*/_react["default"].createElement(_SttContainerTitle["default"], {
    botaoAcoes: botaoAcoes,
    onClickVoltar: onClickVoltar,
    botoes: botoes,
    titulo: titulo
  })), /*#__PURE__*/_react["default"].createElement("main", {
    className: classes.content,
    ref: contentElementRef
  }, filteredConteudo.map(function (item, index) {
    if (!item.id) {
      item.id = item.titulo;
    }
    var temDados = Array.isArray(item.dados) && item.dados.length > 0;
    return /*#__PURE__*/_react["default"].createElement("section", {
      key: item.id,
      id: item.id,
      ref: function ref(el) {
        return contentRefs.current[item.id] = el;
      },
      tabIndex: -1,
      style: {
        marginTop: index < filteredConteudo.length - 1 ? 12 : 0,
        marginBottom: index < filteredConteudo.length - 1 ? 12 : 0
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
      variant: "h3",
      color: "primary",
      className: classes.titulo
    }, item.titulo), (item === null || item === void 0 ? void 0 : item.tipo) === TIMELINE && temDados ? /*#__PURE__*/_react["default"].createElement(_SttTimeLine["default"], {
      props: item
    }) : temDados ? /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.linhasDados
    }, item.dados.filter(Boolean).map(function (dado, idx, array) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: idx
      }, dado.titulo ? /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.gridDados
      }, /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
        className: classes.conteudoTitulo
      }, dado.titulo), /*#__PURE__*/_react["default"].createElement(_SttText["default"], {
        className: classes.conteudoValor
      }, dado.valor)) : /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          textAlign: 'start'
        }
      }, dado.valor), idx < array.length - 1 && /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
        style: {
          marginTop: 4,
          marginBottom: 4
        }
      }));
    })) : item.children, index < filteredConteudo.length - 1 && /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
      className: classes.dividerCelular
    }));
  }))));
});
var _default = SttSection;
exports["default"] = _default;